import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import { BASE_URL } from "../../App";

const PostWarrentyStatus = () => {
  const [loginId, setLoginId] = useState(null);
  const [branchCode, setBranchCode] = useState(null);

  useEffect(() => {
    const USER_ID = localStorage.getItem("USER_ID");
    const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

    const fetchData = async () => {
      try {
        // Optional decoding (commented out)
        // const loginRes = await axios.post(BASE_URL + "/getloginidDecode", { login_id: USER_ID });
        // setLoginId(loginRes.data.login_id);

        const branchRes = await axios.post(BASE_URL + "/getBranchDecode", { BRANCH_CODE });
        setBranchCode(branchRes.data.BRANCH_CODE || BRANCH_CODE);

        setLoginId(USER_ID);
      } catch (error) {
        console.error("Error in login/branch decoding:", error);
        Swal.fire("Error", "Failed to decode login or branch", "error");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (loginId && branchCode) {
      const redirectUrl = `https://mobile.cri.in/others/cridms_app/cridms_v9.3.2/validate_dms.php?usercode=${loginId}&branch_code=${branchCode}&auth=1a223ddee21gexghhc&act=service_cliam_non_serialno`;
      
    
      window.open(redirectUrl, "_blank");
    }
  }, [loginId, branchCode]);

  return <div>LOADING...</div>;
};

export default PostWarrentyStatus;
